



















































import eventBus from '@/utils/eventBus';
import { Component, Prop } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import basePagination from '@/components/BasePagination/BasePagination.vue';
import { Header, Searchable, Modal, getMethod } from './TableBuilderModel';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';

@Component({
  components: {
    RowsTable,
    CustomSelect,
    TextInput,
    Table,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon
  }
})
export default class TableList extends basePagination {
  @Prop({ default: (item: any) => item }) normalizer!: (item: any) => any;
  @Prop({ default: null }) onRowClick!: (event: any) => void;
  @Prop({ default: null }) modal!: Modal;
  @Prop({ default: null }) defaultQuery!: string;
  @Prop({ default: null }) rowsTableProps?: any;
  @Prop({ default: null }) tableProps?: any;
  @Prop({ required: true }) service!: any;
  @Prop({ required: true }) getMethod!: getMethod;
  @Prop({ default: '' }) title!: string;
  @Prop({ required: true }) headers!: Header[];
  @Prop({ required: false }) searchables!: Searchable[];
  @Prop({ default: '' }) defaultSort!: string;

  data: List = new List([], []);
  searchablesValues: string[] = [];
  queryAux = true;
  sortAux = true;

  created() {
    if (this.defaultSort) {
      this.sortChanged(this.defaultSort);
    }
  }

  searchBy(event: string, field: string) {
    this.searchableFields = field;
    this.filterBySearch(event);
  }

  reloadList(clearList?: boolean, refreshCurrent?: boolean, query?: string) {
    if (this.defaultQuery && this.queryAux) {
      this.query = this.defaultQuery;
      this.queryAux = false;
    }

    if (this.defaultSort && this.sortAux) {
      const [sortField, sortOrder] = this.defaultSort.split(':');
      this.sortField = sortField;
      this.sortOrder = sortOrder;
      this.sortAux = false;
    }

    if (clearList) {
      this.resetPagination();
      this.data.list = [];
      this.maxItems = false;
    }

    if (this.refreshing || this.maxItems) return;

    this.$showLoaderWithLocker();
    this.refreshing = true;
    const {
      args = [this.sortField, this.sortOrder, this.pagination, this.query],
      method
    } = this.getMethod;

    this.service[this.getMethod.method](...args)
      .then((response: any) => {
        this.$emit('onLoad', response.data);

        const { items, links, total } = response.data;
        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.data.list = this.normalizer(items);
        } else {
          // refresh page and add items
          this.data.list = this.data.list.concat(this.normalizer(items));
        }

        this.pagination = links.next;
        if (!links.next) this.maxItems = true;
      })
      .catch(() => {})
      .finally(() => {
        this.$hideLoader();
        this.isLoading = true;
        this.refreshing = false;
      });
  }

  detail(event: any) {
    if (this.onRowClick) this.onRowClick(event);
    if (this.modal) {
      const { component, data = event } = this.modal;

      const modalConfig = {
        isOpen: true,
        component: typeof component === 'string' ? component : component(event),
        data: typeof data === 'function' ? data(event) : data
      };

      eventBus.$emit('setSideModalVisible', modalConfig);
    }
  }

  initHeader() {
    this.data.header = this.headers.map(
      ({ label, field, padding }) =>
        new HeaderList(label, field ? field : 'none', padding)
    );
  }
}
